import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { SubDomainValidatorDirective } from '@web/core/validators/sub-domain.validator';
import { PageNameValidatorDirective } from '@web/core/validators/page-name.validator';
import { PageUrlValidatorDirective } from '@web/core/validators/page-url.validator';

import { CreateNewWebsiteModalComponent } from './create-new-website-modal/create-new-website-modal.component';
import { CreateNewPageModalComponent } from './create-new-page-modal/create-new-page-modal.component';
import { SaveConfirmModalComponent } from './save-confirm-modal/save-confirm-modal.component';
import { ExitPageModalComponent } from './exit-page-modal';
import { ImageEditorModalComponent } from './image-editor-modal/image-editor-modal.component';
import { CopyToPageModalComponent } from '@web/shared/modals/copy-to-page-modal/copy-to-page-modal.component';
import { ConfirmDeleteUserBlockModalComponent } from './confirm-delete-user-block/confirm-delete-user-block-modal.component';
import { CreateBlockModalComponent } from './create-block-modal/create-block-modal.component';
import { DeleteSharedBlockModalComponent } from './delete-shared-block-modal/delete-shared-block-modal.component';
import { ResetSiteVersionModalComponent } from './reset-site-version-modal/reset-site-version-modal.component';
import { CtaAfterPublishModalComponent } from './cta-after-publish-modal/cta-after-publish-modal.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

const DIRECTIVES = [SubDomainValidatorDirective, PageNameValidatorDirective, PageUrlValidatorDirective];

const MODALS = [
    CreateNewPageModalComponent,
    CreateNewWebsiteModalComponent,
    SaveConfirmModalComponent,
    ImageEditorModalComponent,
    ExitPageModalComponent,
    CopyToPageModalComponent,
    ConfirmDeleteUserBlockModalComponent,
    CreateBlockModalComponent,
    DeleteSharedBlockModalComponent,
    ResetSiteVersionModalComponent,
    CtaAfterPublishModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        BsDropdownModule,
        NgSelectModule,
        TooltipModule,
        ...DIRECTIVES,
        ...MODALS,
    ],
    exports: [PageNameValidatorDirective, PageUrlValidatorDirective],
})
export class ModalsModule {}
